import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Whatsapp from "../components/util/Whatsapp";
import { whatsappUrl } from "../components/util/whatsappUrl";
import { trackWhatsapp } from "../components/util/analytics";

const BrokenFlow = () => (
  <svg
    viewBox="0 0 420 300"
    role="img"
    aria-labelledby="nf-title"
    className="w-full max-w-xs xl:max-w-md"
  >
    <title id="nf-title">Fluxo de processo com uma etapa faltando, examinada por uma lupa</title>
    <defs>
      <linearGradient id="nf-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#0582CA" stopOpacity="0.18" />
        <stop offset="1" stopColor="#0582CA" stopOpacity="0.02" />
      </linearGradient>
    </defs>

    <circle cx="210" cy="150" r="140" fill="url(#nf-bg)" />

    <g stroke="#0582CA" strokeWidth="3" fill="#ffffff">
      <rect x="40" y="135" width="90" height="60" rx="14" />
      <rect x="290" y="135" width="90" height="60" rx="14" />
    </g>
    <g stroke="#0582CA" strokeWidth="3" strokeLinecap="round" opacity="0.45">
      <line x1="58" y1="157" x2="112" y2="157" />
      <line x1="58" y1="173" x2="96" y2="173" />
      <line x1="308" y1="157" x2="362" y2="157" />
      <line x1="308" y1="173" x2="346" y2="173" />
    </g>

    <rect
      x="165" y="135" width="90" height="60" rx="14"
      fill="none" stroke="#0582CA" strokeWidth="3" strokeDasharray="8 8" opacity="0.6"
    />

    <g stroke="#0582CA" strokeWidth="3" strokeLinecap="round">
      <line x1="130" y1="165" x2="158" y2="165" />
      <line x1="255" y1="165" x2="283" y2="165" />
    </g>
    <g fill="#0582CA">
      <path d="M156 159 l10 6 -10 6z" />
      <path d="M281 159 l10 6 -10 6z" />
    </g>

    <g transform="translate(210 118)">
      <line x1="20" y1="20" x2="42" y2="42" stroke="#0582CA" strokeWidth="8" strokeLinecap="round" />
      <circle cx="0" cy="0" r="28" fill="#ffffff" stroke="#0582CA" strokeWidth="4" />
      <circle cx="0" cy="0" r="12" fill="#ffcf00" />
      <text
        x="0" y="5.5"
        textAnchor="middle"
        fontFamily="Sora, Inter, sans-serif"
        fontWeight="700"
        fontSize="16"
        fill="#0582CA"
      >
        ?
      </text>
    </g>
  </svg>
);

const NotFound = () => {
  useEffect(() => {
    const previous = document.title;
    document.title = "Página não encontrada | Hawx Soluções";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <>
      <Header />
      <main className="bg-white">
        <div className="text-black w-3/4 mx-auto grid xl:grid-cols-2 xl:pt-48 pt-32 pb-24 xl:pb-32">
          <div className="xl:col-start-1 xl:self-end">
            <p className="text-sm font-semibold uppercase tracking-widest text-pattern mb-4">Erro 404</p>
            <h1 className="text-4xl xl:text-6xl font-semibold leading-[1.1] mb-6">
              Essa página não existe
            </h1>
          </div>

          <div className="xl:col-start-2 xl:row-start-1 xl:row-span-2 xl:self-center flex justify-center xl:justify-end mb-10 xl:mb-0">
            <BrokenFlow />
          </div>

          <div className="xl:col-start-1 xl:self-start">
            <p className="text-xl leading-relaxed text-gray-700 mb-10">
              O endereço pode estar errado ou a página foi removida. O que a gente faz, você encontra na página inicial.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/"
                className="bg-pattern text-white font-semibold py-4 px-8 rounded-2xl text-center hover:brightness-95 transition"
              >
                Voltar para o início
              </a>
              <a
                href={whatsappUrl("Olá! Vi o site da Hawx e quero conversar sobre um projeto.")}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsapp("404")}
                className="bg-secondary text-black font-semibold py-4 px-8 rounded-2xl text-center hover:brightness-95 transition"
              >
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </div>
      </main>
      <Whatsapp />
      <Footer />
    </>
  );
};

export default NotFound;
